import { render, staticRenderFns } from "./ServiceRequestsView.vue?vue&type=template&id=ddc2de22&"
import script from "./ServiceRequestsView.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports